import {Decoder, equal, oneOf} from 'json-bouncer'
import {set} from './DecodeHelper'
import {Set} from 'immutable'

export type OrderExportOption =
    | 'PrintData'
    | 'UpsCsv'
    | 'DmsCsv'
    | 'DeliveryNotes'
    | 'Invoices'
    | 'JobSheets'

export function all(): OrderExportOptions {
    const options: OrderExportOption[] = [
        'PrintData',
        'UpsCsv',
        'DmsCsv',
        'DeliveryNotes',
        'Invoices',
        'JobSheets',
    ]
    return Set(options)
}

export type OrderExportOptions = Set<OrderExportOption>

export function decoder(): Decoder<OrderExportOptions> {
    const
        printData: OrderExportOption = 'PrintData',
        upsCsv: OrderExportOption = 'UpsCsv',
        dmsCsv: OrderExportOption = 'DmsCsv',
        deliveryNotes: OrderExportOption = 'DeliveryNotes',
        invoices: OrderExportOption = 'Invoices',
        jobSheets: OrderExportOption = 'JobSheets'
    return set(
        oneOf(
            [
                equal(printData),
                equal(upsCsv),
                equal(dmsCsv),
                equal(deliveryNotes),
                equal(invoices),
                equal(jobSheets),
            ]
        )
    )
}

export function needsPositions(options: OrderExportOptions): boolean {
    return options.has('PrintData') || options.has('DmsCsv')
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/OrderExportOptions.ts